'use client';

import React from 'react';
import { useUserSettings } from 'src/hooks/users';
import { NavCallout } from '../NavCallout';

const SETTING_KEY = 'hasSeenMenuChangesV2';

interface MenuChangesCalloutProps {
  triggerRef: React.RefObject<HTMLDivElement | null>;
}

const MenuChangesCallout = ({ triggerRef }: MenuChangesCalloutProps) => {
  const { getSetting, setSetting, isHydrated } = useUserSettings();

  const hasSeen = getSetting<boolean>(SETTING_KEY) === true;
  const shouldShow = isHydrated && !hasSeen;

  if (!shouldShow) return null;

  return (
    <NavCallout
      triggerRef={triggerRef}
      title="We moved a few things!"
      description="Chat support and more are now in this menu."
      onDismiss={() => setSetting(SETTING_KEY, true)}
    />
  );
};

export default MenuChangesCallout;
